import { Lock, Square } from 'lucide-react'
import type { ChipDefinition, ChipId } from '../types'
import type { ChipStatus, ChipUsedDetail } from '../chipStatus'
import { CHIP_ICONS } from './chipIcons'
import './ChipRow.css'

export type { ChipStatus, ChipUsedDetail }

const LOCKED_LIKE_STATUSES: ChipStatus[] = [
  'locked',
  'ineligible',
  'cooldown',
  'comingSoon',
  'deadlineLocked',
]

interface ChipRowProps {
  chips: ChipDefinition[]
  getStatus: (chipId: ChipId) => ChipStatus
  // Optional short suffix (e.g. "GW19") shown next to a locked chip's label.
  getStatusDetail?: (chipId: ChipId) => string | undefined
  getUsedDetail?: (chipId: ChipId) => ChipUsedDetail | undefined
  onSelectChip: (chipId: ChipId) => void
}

function ChipRow({ chips, getStatus, getStatusDetail, getUsedDetail, onSelectChip }: ChipRowProps) {
  return (
    <div className="chip-row">
      {chips.map((chip) => {
        const status = getStatus(chip.id)
        const detail = status === 'locked' ? getStatusDetail?.(chip.id) : undefined
        const usedDetail = status === 'used' ? getUsedDetail?.(chip.id) : undefined
        const Icon = LOCKED_LIKE_STATUSES.includes(status) ? Lock : (CHIP_ICONS[chip.id] ?? Square)

        return (
          <button
            key={chip.id}
            className={`chip-row__item chip-row__item--${status}`}
            onClick={() => onSelectChip(chip.id)}
          >
            <span className={`chip-row__circle${status === 'active' ? ' chip-glow' : ''}`}>
              <Icon aria-hidden="true" />
            </span>
            {status === 'active' &&
            (chip.id === 'doubleUp' || chip.id === 'goalfest' || chip.id === 'cleanSweep') ? (
              <span className="chip-row__label chip-row__label--stacked">
                <span>{chip.name.toUpperCase()}</span>
                <span>ACTIVATED</span>
              </span>
            ) : status === 'used' ? (
              <span className="chip-row__label chip-row__label--stacked">
                <span>{chip.name.toUpperCase()}</span>
                {usedDetail && (
                  <span className="chip-row__played-gw">Played GW {usedDetail.gameweek}</span>
                )}
              </span>
            ) : (
              <span className="chip-row__label">
                {chip.name.toUpperCase()}
                {detail && ` · ${detail}`}
              </span>
            )}
          </button>
        )
      })}
    </div>
  )
}

export default ChipRow
